import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Topnav from "./components/common/Topnav";
import Footer from "./components/common/Footer";
import { Helmet } from "react-helmet";
import img from "./Images/commonimg/404-removebg-preview.png";

const NotFoundPage = () => {
  const [schools, setSchools] = useState([]); // ✅ Fixed const
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const res = await axios.get(
          "https://isbmuniversity.edu.in/admin-portal/schoolsApi",
        );
        setSchools(res.data?.data || []);
      } catch (error) {
        console.error("Error fetching schools:", error);
      }
    };

    fetchSchools();
  }, []);

  return (
    <>
      {/* ✅ Proper SEO handling */}
      <Helmet>
        <title>404 Not Found – ISBM University</title>
        <meta
          name="description"
          content="The page you are looking for cannot be found. Explore ISBM University’s schools and return to the homepage."
        />
      </Helmet>

      <Topnav />

      <section
        className="py-5 bg-light d-flex align-items-center"
        style={{ minHeight: "70vh" }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT SIDE */}
            <div className="col-lg-6 text-center mb-4 mb-lg-0">
              <img src={img} alt="404 Not Found" className="img-fluid" />
              <h2 className="fw-bold text-dark mb-2">
                404 Error - Webpage not found.
              </h2>

              <p className="text-muted mb-4">
                Mistakes are proof you're trying. Remember, even Albert Einstein
                made mistakes.
              </p>

              {/* Google Site Search */}
              <div className="mt-4">
                <form
                  action="https://www.google.com/search"
                  method="GET"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="input-group shadow-sm">
                    <input
                      type="text"
                      name="q"
                      className="form-control form-control-lg"
                      placeholder="Search about ISBM University on Google..."
                      required
                    />
                    <input
                      type="hidden"
                      name="as_sitesearch"
                      value="isbmuniversity.edu.in"
                    />
                    <button className="btn btn-blue px-4">Search</button>
                  </div>
                </form>
              </div>

              <div className="mt-4">
                <Link
                  to="/"
                  className="btn btn-purple btn-lg rounded-pill px-4"
                >
                  Return To Home Page
                </Link>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-6">
              <h5 className="fw-bold mb-4">Explore Course Categories</h5>

              <div className="row">
                {(showAll ? schools : schools.slice()).map((school, index) => (
                  <div className="col-md-6 mb-2" key={index}>
                    <ul className="list-group list-group-flush shadow-sm rounded h-100">
                      <li className="list-group-item d-flex justify-content-between align-items-center school-link-item h-100">
                        <Link
                          to={`/school-details/${school.name}`}
                          className="text-decoration-none text-dark fw-semibold w-100 d-flex justify-content-between align-items-center"
                        >
                          {school.title.replace("School of ", "") + " Courses"}
                          <i className="ti ti-arrow-right text-primary"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                ))}
              </div>

              {/* View More / View Less Button */}
              {/* {schools.length > 6 && (
                <div className="mt-3 text-center">
                  <button
                    className="btn btn-blue btn-sm rounded-pill px-4"
                    onClick={() => setShowAll(!showAll)}
                  >
                    {showAll ? "View Less" : "View More Schools"}
                  </button>
                </div>
              )} */}

              <style>{`
              .school-link-item {
                transition: all 0.3s ease;
                cursor: pointer;
              }

              .school-link-item:hover {
                background-color: #f8f9fa;
                transform: translateX(5px);
              }
            `}</style>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default NotFoundPage;
